module.exports = __webpack_public_path__ + "img/check_gray-light.31b18b7a.svg";